export default __webpack_public_path__ + "static/media/mus-crew.e4d55ea8.mp4";